import React, { lazy } from 'react';
import { HelpCircleIcon } from 'lucide-react';
export function SASSInfo() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-915">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-916">
        {/* SASS Banner Image */}
        <div className="mb-10 rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-917">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/SASS%20Banner.jpg" alt="Single Action Shooting Society (SASS) Banner" className="block w-full h-auto" loading="lazy" data-id="element-918" />
        </div>

        {/* Title block */}
        <div className="text-center mb-10" data-id="element-919">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-2" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-920">
            Single Action Shooting Society (SASS)
          </h2>
          <p className="text-lg" style={{
          color: '#4a6a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-921">
            AKA — Cowboy Action Shooting (CAS)
          </p>
        </div>

        {/* Body content */}
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border mb-12" style={{
        borderColor: '#ede9e0'
      }} data-id="element-922">
          <div className="space-y-5" data-id="element-923">
            <p className="text-base leading-relaxed" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-924">
              Cowboy Action Shooting (CAS) is a competitive shooting sport using
              guns that would be typical of those used in the "old west." Some
              call it 3 gun with old fashioned guns. The guns used are single
              action revolvers, lever action or pump action rifles and double
              barrel or pump or lever action shotguns.
            </p>
            <p className="text-base leading-relaxed" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-925">
              Competitors are timed through a series of stages or scenarios
              using a combination of these guns shooting live ammo at steel
              targets. A typical match consists of 5 or 6 stages in which the
              competitor will shoot 10 pistol, 10 rifle and 4 shotgun in each
              stage.
            </p>
            <p className="text-base leading-relaxed" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-926">
              In Michigan there are 13 locations that offer CAS matches. There
              are CAS matches in every state and all over the planet. World
              wide, there are CAS matches in Canada, Australia, New Zealand,
              Europe, South Africa and the Orient. All these locations play by
              the same rules and are sanctioned by the Single Action Shooting
              Society. At last count, there were approximately 75,000 cowboy
              shooters across the globe.
            </p>
            <p className="text-base leading-relaxed" style={{
            color: '#2a2a2a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-927">
              Annually each state conducts a state championship match and there
              is a world championship match conducted each year. The Michigan
              championship match is a two day match over the Labor Day weekend.
            </p>
          </div>

          {/* FAQ Link */}
          <div className="flex items-center gap-3 mt-6 p-4 rounded-lg" style={{
          backgroundColor: 'rgba(200,168,75,0.08)',
          border: '1px solid rgba(200,168,75,0.2)'
        }} data-id="element-928">
            <HelpCircleIcon size={20} className="flex-shrink-0" style={{
            color: '#c8a84b'
          }} data-id="element-929" />
            <a href="https://www.fentonlakes.com/57.html" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold transition-colors hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-930">
              Still have questions? Click here for the Cowboy Action Shooting
              FAQ
            </a>
          </div>
        </div>
      </div>
    </div>;
}